import { FetchPolicy } from '@apollo/client'
import { usePartsQuery } from '../graphql'

export default function usePartsSearch( search: string, debounceKey = 'partsQuery-debounce' ) {
	const queryParams = {
		context: { debounceKey },
		fetchPolicy: 'no-cache' as FetchPolicy,
		variables: { search },
	}

	return usePartsQuery( queryParams )
}
